module.exports = __webpack_public_path__ + "teqbahn-assets/media/umedme_gray.993f734b.png";